module.exports = __webpack_public_path__ + "img/MonitorScoreExams.f562378d.svg";